"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiTimeAttendance {
    static getPtoBalances(token, employeeId = null) {
        let url = `/timeattendance/pto`;
        if (employeeId != '' && employeeId != null) {
            url += `?employeeId=${employeeId}`;
        }
        return Client_1.default.httpGet(url, token).then((data) => {
            if (data?.balances) {
                for (let item of data?.balances) {
                    if (item?.name) {
                        item.name = item.name.replaceAll(' Grandfathered', '');
                    }
                }
            }
            return data;
        });
    }
    static getTeamAgenda(token) {
        let url = `/timeattendance/teamAgenda`;
        return Client_1.default.httpGet(url, token);
    }
    static getApprovals(token) {
        let url = `/timeattendance/getApprovals`;
        return Client_1.default.httpGet(url, token).then((data) => data);
    }
    static getPTORequests(token, limit = null) {
        let url = `/timeattendance/getPTORequests`;
        if (limit) {
            url = url + `?limit=` + limit;
        }
        return Client_1.default.httpGet(url, token);
    }
    static approveOrDenyPTORequest(token, body) {
        let url = `/timeattendance/approveDenyPTORequest`;
        return Client_1.default.httpPost(url, token, body);
    }
    static sendPTORequest(token, body) {
        let url = `/timeattendance/pto`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getPTORegisters(token) {
        let url = `/timeattendance/register`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeePtoRequests(token, since, employeeId) {
        let url = `/timeattendance/pto/request`;
        if (since != '' && since != null) {
            url += `?since=` + since;
        }
        if (employeeId != '' && employeeId != null) {
            url += `${url.includes("?") ? "&" : "?"}employeeId=${employeeId}`;
        }
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeePtoHistory(token, employeeId) {
        let url = `/timeattendance/pto/history`;
        if (employeeId != '' && employeeId != null) {
            url += `?employeeId=${employeeId}`;
        }
        return Client_1.default.httpGet(url, token);
    }
    static cancelPTORequest(token, body) {
        let url = `/timeattendance/pto/request`;
        return Client_1.default.httpDelete(url, token, body);
    }
    static editPtoRequest(token, body) {
        const url = `/timeattendance/pto/request`;
        return Client_1.default.httpPut(url, token, body);
    }
    static sendPunch(token, body) {
        let url = `/timeattendance/punch`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getLastPunch(token) {
        let url = `/timeattendance/punch`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiTimeAttendance;
